<template>
  <div class="form-elements">
    <div class="row">
      <div class="flex xs12">
        <va-card stripe="secondary" :title="$t('menu.detailing')">
          <form ref="form">
            <div class="row">
              <div class="flex md4 sm6 xs12">
                  <va-icon name="fa fa-user mr-2" color="success" />
                  {{ $t("forms.inputs.login") }}
                  <h5 class="mt-0 mb-0">{{ userParams.login }}</h5>
              </div>

              <div class="flex md4 sm6 xs12">
                <va-icon name="fa fa-user-circle mr-2" color="success" />
                {{ $t("tables.users.name") }}
                <h5 class="mt-0 mb-0">{{ userParams.name }}</h5>
              </div>

              <div class="flex md4 sm6 xs12">
                <va-icon name="fa fa-vcard-o mr-2" color="success" />
                {{ $t("forms.inputs.cpf") }}
                <h5 class="mt-0 mb-0">{{ userParams.cpf }}</h5>
              </div>

              <div class="flex md4 sm6 xs12">
                <va-icon name="fa fa-mail-forward mr-2" color="success" />
                {{ $t("forms.inputs.email") }}
                <h5 class="mt-0 mb-0">{{ userParams.email }}</h5>
              </div>

              <div class="flex md4 sm6 xs12">
                <va-icon name="fa fa-map-marker mr-2" color="success" />
                {{ $t("forms.inputs.timezone") }}
                <h5 class="mt-0 mb-0">{{ userParams.timezone }}</h5>
              </div>

              <div class="flex md4 sm6 xs12">
                <va-icon name="fa fa-language mr-2" color="success" />
                {{ $t("forms.inputs.language") }}
                <h5 class="mt-0 mb-0">{{ userParams.locale }}</h5>
              </div>

              <va-card stripe="secondary" class="flex xs12">
                <div class="row">
                <div class="flex md4 sm6 xs12">
                  <b>{{ $t('menu.localities') }}</b>
                  <table class="va-table">
                    <thead>
                      <tr>
                        <th>{{ $t('forms.inputs.name') }}</th>
                      </tr>
                    </thead>

                    <tbody>
                      <tr v-for="user_locality in userLocalities" :key="user_locality.locality_id">
                        <td>{{ user_locality.locality_name }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                
                <div class="flex md4 sm6 xs12">
                  <b>{{ $t('menu.pallets') }}</b>
                  <table class="va-table">
                    <thead>
                      <tr>
                        <th>{{ $t('forms.inputs.name') }}</th>
                      </tr>
                    </thead>

                    <tbody>
                      <tr v-for="pallet_user in userPalletTypes" :key="pallet_user.id">
                        <td>{{ pallet_user.name }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                  
                <div class="flex md4 sm6 xs12">
                  <b>{{ $t('menu.roles') }}</b>
                  <table class="va-table">
                    <thead>
                      <tr>
                        <th>{{ $t('forms.inputs.name') }}</th>
                      </tr>
                    </thead>

                    <tbody>
                      <tr v-for="role in userRolesParams" :key="role.id">
                        <td>{{ role.name }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                </div>
              </va-card>
            </div>

          <div class="row">
            <div class="flex md4 sm6 xs12">
              <va-button
                medium
                inline
                color="#ff842b"
                icon="fa fa-chevron-left"
                class="ma-0"
                :to="{ name: 'users', params: {
                current_page: this.$route.params.current_page, 
                searchName: this.$route.params.searchName, 
                perPage: this.$route.params.perPage }
                }"
              >
                {{ $t('menu.back') }}
              </va-button>
            </div>
          </div>
        </form>
        </va-card>
      </div>
    </div>
  </div>
</template>

<script>

import UserAPI from '@/services/UserAPI'
import UserRoleAPI from '@/services/UserRoleAPI'
import PalletUserAPI from '@/services/PalletUserAPI'
import UserLocalityAPI from '@/services/UserLocalityAPI' 

export default {
  name: 'form-users',
  components: {},
  data () {
    return {
      userParams: {
        login: '',
        password: '',
        name: '',
        cpf: '',
        email: '',
        timezone: '',
        locale: '',
        roles: '',
      },
      userRolesParams: [],
      userPalletTypes: [],
      userLocalities: []
    }
  },
  mounted() {
    if (this.$route.params.id != undefined) {
      UserAPI.getUserById(this.$route.params.id).then(response => {
        let res = response.data.user

        this.userParams.login = res.login
        this.userParams.name = res.name
        this.userParams.password = res.password
        this.userParams.cpf = res.cpf
        this.userParams.email = res.email
        this.userParams.timezone = res.timezone
        this.userParams.locale = res.locale
      })
    }
    UserRoleAPI.getRoleByUserId(this.$route.params.id).then(response => {
        this.userRolesParams = response.data.roles
    }),

    PalletUserAPI.getAllPalletUserByUser(this.$route.params.id).then(response => {
        this.userPalletTypes = response.data.pallet_users_by_user
    }),

    UserLocalityAPI.getUserLocalitiesByUser(this.$route.params.id).then(response =>{
        this.userLocalities = response.data.user_localities
    })
  }
}
</script>


